import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { SystemBase } from '@inter-ikea-core/core-toolbox';
import AdjustableComponent from '../components/AdjustableComponent';
import { CLOTH_RAIL_ALIGN_SERIES_LEFT, CLOTH_RAIL_ALIGN_SERIES_RIGHT, CLOTH_RAIL_INSIDE_CONNECTOR_KEY, CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY } from '../types';
import { addRequiredSizeAdjustmentComponent, measureClothRailToTheRight } from './FrameDragAdaptAdjustableClothRailSystem';
/**
 * Systems that expands a cloth rail after it has been connected to a frame on the right side or inside of it.
 */
export class ExpandClothRailSystem extends SystemBase {
    constructor(coreApi) {
        super(ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID);
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = [];
        this.systemsAfterMe = null;
        this.id = 'ExpandClothRailSystem';
        this.coreApi = coreApi;
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        if (!_entity.hasComponent(AdjustableComponent.id)) {
            return;
        }
        // Snapped on the right outside of the frame
        if (_newComponent.snap.hostConnector.key.includes(CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY)) {
            const outerhit = measureClothRailToTheRight(this.coreApi, _entity);
            const entityHit = outerhit?.entity;
            if (!entityHit)
                return;
            const outerHitEntity = entityHit?.hasComponent(ComponentIds.FRAME_COMPONENT_ID)
                ? entityHit
                : HierarchyUtils.findWithComponentInUpwardsHierarchy(entityHit, ComponentIds.FRAME_COMPONENT_ID);
            if (outerhit && outerHitEntity) {
                addRequiredSizeAdjustmentComponent(_entity, outerHitEntity, CLOTH_RAIL_ALIGN_SERIES_LEFT + _newComponent.snap.hostConnector.key.split('-').pop());
            }
        }
        else if (_newComponent.snap.hostConnector.key.includes(CLOTH_RAIL_INSIDE_CONNECTOR_KEY)) {
            addRequiredSizeAdjustmentComponent(_entity, _newComponent.snap.host, CLOTH_RAIL_ALIGN_SERIES_RIGHT + _newComponent.snap.hostConnector.key.split('-').pop());
        }
    }
}
//# sourceMappingURL=ExpandClothRailSystem.js.map